import { Directive, Injectable } from '@angular/core';
import { ApiService } from '@red/api';
import { Mixin } from 'ts-mixer';
import { DynamicReportApiService, DynamicReportCollection } from './dynamic-report-api.service';


@Directive()
abstract class ProjectDynamicReportsApiService extends DynamicReportApiService {
  collectionEndpoint = DynamicReportCollection.ProjectReport;
}
@Directive()
abstract class ResaleDynamicReportsApiService extends DynamicReportApiService {
  collectionEndpoint = DynamicReportCollection.ResaleReport;
}
@Injectable({
  providedIn: 'root',
})
export class ProjectDynamicReportApiService extends ProjectDynamicReportsApiService { }

@Injectable({
  providedIn: 'root',
})
export class ResaleDynamicReportApiService extends ResaleDynamicReportsApiService { }
